import store from '../store';

export default async function entryProspectList({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryProspectList');

    if (store.getters.isAuthenticated)
        return router.push({ name: "ProspectSearch" });
    else
        return router.push({ name: "Login" });


    return next();
}
